var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { LocationSearchInputComponent } from '../location-search-input/location-search-input.component';
import { LocaleAwareBaseComponent } from './../../seo/locale-aware-base.component';
var GmapsInterfaceComponent = /** @class */ (function (_super) {
    __extends(GmapsInterfaceComponent, _super);
    function GmapsInterfaceComponent() {
        var _this = _super.call(this) || this;
        _this.activeMode = 'drive';
        _this.travelModeChanged = new EventEmitter();
        return _this;
    }
    GmapsInterfaceComponent.prototype.changeTravelMode = function (mode) {
        if (mode.travelMode !== this.activeMode) {
            this.isInfoHidden = true;
            this.activeMode = mode.travelMode;
            this.travelModeChanged.next(mode.travelMode);
        }
    };
    return GmapsInterfaceComponent;
}(LocaleAwareBaseComponent));
export { GmapsInterfaceComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-interface/gmaps-interface.component.ts.pre-build-optimizer.js